import { render, staticRenderFns } from "./TreeM.vue?vue&type=template&id=50cf7afc&scoped=true"
import script from "./TreeM.vue?vue&type=script&lang=js"
export * from "./TreeM.vue?vue&type=script&lang=js"
import style0 from "./TreeM.vue?vue&type=style&index=0&id=50cf7afc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf7afc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50cf7afc')) {
      api.createRecord('50cf7afc', component.options)
    } else {
      api.reload('50cf7afc', component.options)
    }
    module.hot.accept("./TreeM.vue?vue&type=template&id=50cf7afc&scoped=true", function () {
      api.rerender('50cf7afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/TreeM.vue"
export default component.exports